import {useEffect, useRef, useState} from 'react';
import {getCompleteInvoices, getPaidInvoices} from "../../api/Api";
import {Table} from 'antd';
import {Link} from "react-router";
import {InvoiceStateWidget} from "../sales/InvoiceStateWidget";
import {InvoiceStatusType} from "../../api/Constants";
import {getColumnSearchProps} from "../widget/SearchProps";

export const PaidInvoice = ({onRefresh, refresh, onApiFail, type="paid", props}) => {
    const [invoices, setInvoices] = useState([]);

    useEffect(() => {
        let promise;
        if (type === "paid") {
            promise = getPaidInvoices();
        } else {
            promise = getCompleteInvoices().then(result => {
                return result.filter(row => row.state === InvoiceStatusType.Complete)
            });
        }
        promise.then(result => {
            setInvoices(result.map(i => {
                return {...i,
                    key: i.id
                }
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [type, refresh, onApiFail]);

    // for use with search props
    const searchInput = useRef(null);

    const columns = [
        {
            title: 'Invoice Number',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
            render: (val, record) => {
                // return <div onClick={selectInvoice(record)} style={{cursor: 'pointer'}}>{val}</div>
                return <Link to={`/invoice/${record.id}`}>{val}</Link>
            },
            ...getColumnSearchProps(`invoiceNumber`, searchInput),
            sorter: (a, b) => a.invoiceNumber.toLowerCase().localeCompare(b.invoiceNumber.toLowerCase()),
        },
        {
            title: 'Buyer',
            dataIndex: 'firstname',
            render: (val, record, index) => {
                return `${val} ${record.lastname}`
            },
            ...getColumnSearchProps(`firstname`, searchInput),
            sorter: (a, b) => {
                const aName = `${a.firstname} ${a.lastname}`;
                const bName = `${b.firstname} ${b.lastname}`;
                return aName.localeCompare(bName);
            }
        },
        {
            title: 'Created by',
            dataIndex: 'username',
            key: 'username',
            sorter: (a, b) => a.username.localeCompare(b.username)
        },
        {
            title: 'Date',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val) => {
                const terms = val.split("T");
                return terms[0]
            },
            sorter: (a, b) => (new Date(a.timestamp))- (new Date(b.timestamp)),
        },
        {
            title: 'Status',
            dataIndex: 'state',
            key: 'state',
            render: (val, record, index) => {
                return <InvoiceStateWidget invoice={record} onApiFail={onApiFail} onRefresh={onRefresh} disabled={false}/>
            },
            sorter: (a, b) => a.state - b.state
        },
        {
            title: 'Subtotal',
            dataIndex: 'subtotal',
            key: 'subtotal',
            render: (val) => {
                return `$ ${val}`;
            },
            sorter: (a, b) => a.subtotal - b.subtotal,
        },
        {
            title: 'Paid',
            dataIndex: 'amountPaid',
            key: 'amountPaid',
            sorter: (a, b) => a.amountPaid - b.amountPaid,
        },
        {
            title: 'Balance',
            dataIndex: 'subtotal',
            key: 'balance',
            render: (val, record, index) => {
                const floatVal = record.subtotal - record.amountPaid;
                const fixedVal = floatVal.toFixed(2);
                return `$ ${fixedVal}`
            },
            sorter: (a, b) => {
                const aBalance = a.subtotal - a.amountPaid;
                const bBalance = b.subtotal - b.amountPaid;
                return aBalance - bBalance;
            },
        }
    ];

    const tablePagination = {
        defaultPageSize: 50,
        showSizeChanger: true,
        pageSizeOptions: [50, 100, 150, 200]
    }

    return <Table dataSource={invoices} columns={columns} pagination={tablePagination}/>
}